var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { todayMinus10Days } from 'src/utils/dateOperations/getISODateText';
import getter from 'src/utils/entityOperations/getter';
import Vue from 'vue';
import Card from '../../../components/Card/Card.vue';
import GenericTable from '../../../components/GenericTable/GenericTable.vue';
export default Vue.extend({
    components: { Card, GenericTable },
    props: {
        classObj: { type: Object, default: null }
    },
    data() {
        return {
            visible: false,
            data: []
        };
    },
    computed: {
        mainTableProps() {
            return {
                localEntityNameProp: 'ci.api_log',
                startingFilterModelProp: [
                    { field: 'request_payload', predicate: 'contains', value: String(this.classObj.native_id), doNotApplyLocally: true },
                    { field: 'requested_at', predicate: 'greaterThanOrEqualTo', value: todayMinus10Days + 'T00:00:00.000Z', doNotApplyLocally: true }
                ],
                title: 'Class native ID ' + this.classObj.native_id + '. Class ID ' + this.classObj.id,
                columnsProp: getter('ci.api_log', 'columns'),
                startingSortingModelProp: [
                    { application_order: 1, field: 'is_outgoing_request', direction: 'desc' },
                    { application_order: 2, field: 'id', direction: 'desc' }
                ]
            };
        }
    },
    watch: {
        'classObj.id': {
            immediate: true,
            handler(newVal) {
                return __awaiter(this, void 0, void 0, function* () {
                    this.visible = true;
                });
            }
        },
        visible(newVal) {
            if (!newVal)
                this.$emit('unloadComponent');
        }
    }
});
